import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import InnForm from "@/components/ds/form/Form.vue";
import { PropType } from "vue";
import { Company } from "@/types";



export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySecondary',
  props: {
    company: {
        type: Object as PropType<Company>,
        required: true,
    },
},
  setup(__props) {



const config = {
    sections: [
        {
            items: [
                {
                    type: "textarea",
                    key: "invoiceText",
                    label: "Factuurtekst",
                },
                {
                    type: "textarea",
                    key: "invoiceTextEnglish",
                    label: "Factuurtekst Engels",
                },
                {
                    type: "color",
                    key: "color1",
                    label: "Kleur 1",
                },
                {
                    type: "color",
                    key: "color2",
                    label: "Kleur 2",
                },
                {
                    type: "image",
                    key: "logoUrl",
                    label: "Logo URL",
                },
                {
                    type: "image",
                    key: "footerImageUrl",
                    label: "Footer URL",
                },
            ],
        },
    ],
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnForm, {
    value: __props.company,
    config: config
  }, null, 8, ["value"]))
}
}

})